export default "__VITE_ASSET__5b49ed8c__"